<!-- 支付结果页面 -->
<template>
  <div class='result_page'>
    <!-- 顶部信息 -->
    <div class="top_wrap">
      <div class="icon_wrap">
        <div class="icon_bg_box"></div>
        <i
          class="reslut_icon ri-2x"
          :class="orderStatus.icon"
        ></i>
      </div>
      <div class="icon_text">{{orderStatus.text}}</div>
    </div>

    <TitleComponent
      v-show="orderInfo.payment.indexOf('offline') == -1"
      :title="'订单信息'"
    />

    <!-- 订单信息 -->
    <div
      class="order_msg_wrap"
      v-show="orderInfo.payment.indexOf('offline') == -1"
    >
      <div class="order_msg_content">
        <div class="order_msg_item">
          <div class="order_msg_title">订单编号</div>
          <div class="order_msg">{{orderInfo.order_no}}</div>
        </div>
        <div class="order_msg_item">
          <div class="order_msg_title">订单信息</div>
          <div class="order_msg">{{orderInfo.goods_name}}</div>
        </div>
        <div class="order_msg_item">
          <div class="order_msg_title">订单金额</div>
          <div class="order_msg">{{params.type == 'rmb' ? '￥' : '＄'}}{{orderInfo.amount}}</div>
        </div>
        <div class="order_msg_item">
          <div class="order_msg_title">创建时间</div>
          <div class="order_msg">{{orderInfo.create_time}}</div>
        </div>
      </div>
    </div>

    <!-- 银行卡支付 -->
    <div
      class="payment_offline_card"
      v-show="orderInfo.payment == 'offline_card'"
    >

      <TitleComponent :title="'银行转账信息（Bank Transfer）'" />

      <!-- 待支付金额 -->
      <div class="amount_wrap">
        <div class="amount_text">您需要支付（Amount）:</div>
        <div class="amount_num">{{params.type == 'rmb' ? '￥' : '＄'}}{{orderInfo.amount}}</div>
      </div>

      <!-- 转账说明 -->
      <div class="transfer_wrap">
        <div class="transfer_item">
          <div class="transfer_item_text">1、请在转账信息中注明“姓名+论文ID+金额”。如有多篇论文，请将论文ID全部列出。</div>
          <div class="transfer_item_text">Please indicate "Name+PaperID+Amount". If more than one paper, please indicate all PaperIDs.</div>
        </div>
        <div class="transfer_item">
          <div class="transfer_item_text">2、请注意：请勿合并汇款，一笔支付对应一张发票，接受柜台转账、手机银行及网银转账，请确保您预留正确的注册邮箱。</div>
          <div class="transfer_item_text">Special notes：in order to avoid your bank transfer to be mixed up with others, please do not consolidate your payments.</div>
        </div>
      </div>

      <!-- 转账信息标题 -->
      <div class="transfer_info_title">Account information for mainland China registrants</div>
      <!-- 转账信息内容 -->
      <div class="transfer_infos">
        <table class="info_table">
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">单位名称</td>
            <td class="info_item_td info_item_text">深圳市智行旅行社有限公司</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">单位地址</td>
            <td class="info_item_td info_item_text">深圳市宝安区福海街道和平社区展城路1号深圳国际会展中心中央廊道B7-102</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">电话号码</td>
            <td class="info_item_td info_item_text">075582880713</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">银行账户</td>
            <td class="info_item_td info_item_text">756267571494</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">开户银行</td>
            <td class="info_item_td info_item_text">中国银行股份有限公司深圳中心区支行</td>
          </tr>
        </table>
      </div>

      <!-- 转账信息标题 -->
      <div class="transfer_info_title">Account information for HK, Macao, Taiwan, and overseas registrants</div>
      <!-- 转账信息内容 -->
      <div class="transfer_infos">
        <table class="info_table">
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">Name</td>
            <td class="info_item_td info_item_text">SHENZHEN SMART TRAVEL CO.,LTD.</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">Address</td>
            <td class="info_item_td info_item_text">B7-102, central corridor, Shenzhen International Convention and Exhibition Center, No.1, Zhancheng Road, Heping community, Fuhai street, Bao'an District, Shenzhen</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">Phone No.</td>
            <td class="info_item_td info_item_text">075582880713</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">Intermediary banker's name</td>
            <td class="info_item_td info_item_text">BANK OF CHINA ,SHENZHEN BRANCH,ZHONGXINQU SUB-BRANCH</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">Account No.</td>
            <td class="info_item_td info_item_text">756267571494</td>
          </tr>
          <tr class="info_table_tr">
            <td class="info_item_td info_item_name">SWIFT CODE</td>
            <td class="info_item_td info_item_text">BKCHCNBJ45A</td>
          </tr>
        </table>
      </div>
      <!-- 重要提示 -->
      <div class="notice_wrap">备注：请您在转账后48小时内将付款截图发送到邮箱（bestmeeting02@163.com），工作人员将为您确认账单并给您发送会议确认短信/邮件。</div>
      <!-- 底部说明 -->
      <div class="offline_desc">
        <div class="offline_desc_item">如有问题请及时与我们联系。</div>
        <div class="offline_desc_item">邮箱：csrswtc2021@ee.cityu.edu.hk bestmeeting02@163.com</div>
        <div class="offline_desc_item">电话：0755-82880052</div>
        <!-- <div class="offline_desc_item color_sty">备注：请您在转账后48小时内将付款截图发送到邮箱（bestmeeting02@163.com），工作人员将为您确认账单并给您发送会议确认短信/邮件。</div> -->
      </div>

    </div>

    <!-- 微信收款 -->
    <div
      class="payment_offline_wx"
      v-show="orderInfo.payment == 'offline_wx'"
    >
      <TitleComponent :title="'微信转账'" />

      <!-- 待支付金额 -->
      <div class="amount_wrap">
        <div class="amount_text">您需要支付（Amount）:</div>
        <div class="amount_num">{{params.type == 'rmb' ? '￥' : '＄'}}{{orderInfo.amount}}</div>
      </div>
      <!-- 支付二维码 -->
      <div class="wxpay_code_wrap">
        <img
          class="code_img"
          :src="wximg"
        >
      </div>
      <!-- 重要提示 -->
      <div class="notice_wrap">备注：请您在转账后48小时内将付款截图发送到邮箱（bestmeeting02@163.com），工作人员将为您确认账单并给您发送会议确认短信/邮件。</div>

      <!-- 底部说明 -->
      <div class="offline_desc">
        <div class="offline_desc_item">如有问题请及时与我们联系。</div>
        <div class="offline_desc_item">邮箱：csrswtc2021@ee.cityu.edu.hk bestmeeting02@163.com</div>
        <div class="offline_desc_item">电话：0755-82880052</div>
        <!-- <div class="offline_desc_item color_sty">备注：请您在转账后48小时内将付款截图发送到邮箱（bestmeeting02@163.com），工作人员将为您确认账单并给您发送会议确认短信/邮件。</div> -->
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer_wrap">

      <!-- 购票成功按钮 -->
      <van-button
        class="result_btn"
        block
        round
        @click="handleToRegister"
        v-show="orderStatus.id == 0 || orderStatus.id == 2 ||orderStatus.id == 3"
      >{{orderStatus.btn_text}}</van-button>
      <!-- 待支付按钮 -->
      <div
        class="wait_pay_wrap"
        v-show="orderStatus.id == 1"
      >
        <div class="price_warp">
          <div class="price_text">注册费：</div>
          <div class="price_num">{{params.type == 'rmb' ? '￥' : '＄'}}{{orderInfo.amount}}</div>
        </div>
        <van-button
          class="wait_pay_btn"
          type="primary"
          plain
          @click="handleWannaPay"
        >{{orderStatus.btn_text}}</van-button>
      </div>

    </div>

    <!-- 加载中 -->
    <Loading :show="loading" />

  </div>
</template>

<script>
import TitleComponent from "@c/titleComponent"
import Loading from '@c/Loading'
import apiObj from '@a/js/api'
import { GetOrderStatus } from '@a/js/api/ieee'

const statusList = [
  {
    id: 0,
    text: '注册成功',
    icon: 'ri-check-line',
    btn_text: '继续注册'
  },
  {
    id: 1,
    text: '等待支付',
    icon: 'ri-time-line',
    btn_text: '前往支付'
  },
  {
    id: 2,
    text: '订单已失效',
    icon: 'ri-close-line',
    btn_text: '重新注册'
  },
  {
    id: 3,
    text: '等待支付',
    icon: 'ri-time-line',
    btn_text: '重新注册'
  },
]
export default {
  name: 'Result',
  data() {
    return {
      apiObj,
      params: {},
      querys: {},
      loading: true,
      statusList,
      orderStatus: {},
      orderInfo: {
        payment: ''
      },
      // 轮询参数
      count: 0,
      time: 0,
      wximg: require('@a/img/ieee/ieee2021wxpay.jpg')
    };
  },

  components: {
    TitleComponent,
    Loading
  },

  methods: {
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        this.querys = this.$route.query
        resolve();
      });
    },
    // 查询订单状态
    wannaOrderStatus() {
      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        order_no: this.params.orderid,
      }
      if (this.querys.token) {
        data.transaction_no = this.querys.token
      }
      // console.log(data)
      GetOrderStatus(data).then(res => {
        // console.log(res)
        this.orderInfo = res.data.order
        if (this.orderInfo.payment.indexOf('offline') != -1) {
          if (this.orderInfo.paid) {
            this.orderStatus = this.statusList[0]
          } else {
            let ctime = new Date().getTime()
            let extime = new Date(this.orderInfo.time_expire.replace(/-/g, '/')).getTime()
            if (ctime > extime) {
              this.orderStatus = this.statusList[2]
            } else {
              this.orderStatus = this.statusList[3]
            }
          }

          this.loading = false
        } else {
          this.setSysteamTime().then(() => {
            this.chargeOrderStatus(res.data.order.paid)
          })
        }

      }).catch(() => { })

    },
    // 判断订单状态
    chargeOrderStatus(status) {
      if (status) {
        this.orderStatus = this.statusList[0]
        this.loading = false
      } else {
        this.ReGetOrderStatus()
      }
    },
    // 配置时间
    setSysteamTime() {
      return new Promise(resolve => {
        this.count++
        switch (this.count) {
          case 1:
            this.time = 200
            break;

          case 2:
            this.time = 500
            break;

          case 3:
            this.time = 1000
            break;

          default:
            break;
        }

        resolve()
      })

    },
    // 轮询订单状态
    ReGetOrderStatus() {
      if (this.count <= 3) {
        setTimeout(() => {
          this.wannaOrderStatus()
        }, this.time);
      } else {
        let ctime = new Date().getTime()
        let extime = new Date(this.orderInfo.time_expire).getTime()
        if (ctime > extime) {
          this.orderStatus = this.statusList[2]
        } else {
          this.orderStatus = this.statusList[1]
        }

        this.loading = false
      }

    },
    // 点击继续注册
    handleToRegister() {
      this.$router.push({
        name: 'Info'
      })
    },
    // 点击继续支付
    handleWannaPay() {
      let api_url =
        apiObj.VUE_APP_BASE_API +
        '/g/v1/pay/pay?account_uid=' + this.params.accountid + '&project_uid=' +
        this.params.projectid + '&order_no=' + this.params.orderid + '&return_url='
      let return_url =
        apiObj.VUE_APP_BASE_SERVE +
        'custom/ieee2021/result/' + this.params.type + '/' +
        this.params.accountid + '/' + this.params.projectid + '/' +
        this.params.orderid
      api_url += return_url
      // console.log(api_url)
      window.location.href = api_url
    }

  },

  mounted() {
    this.GetParamsData().then(() => {
      this.wannaOrderStatus()
    })
  },
}
</script>
<style lang='less' scoped>
.result_page {
  overflow: auto;
  padding-bottom: 80px;
  min-height: 100vh;
  max-height: 100vh;
  box-sizing: border-box;
  // 顶部信息
  .top_wrap {
    margin: 60px 0 0;
    overflow: hidden;
    .icon_wrap {
      position: relative;
      .icon_bg_box {
        margin: 0 auto;
        height: 100px;
        width: 100px;
        border-radius: 50px;
        background-color: var(--btnBgColor);
        opacity: 0.05;
      }
      .reslut_icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateY(-50%) translateX(-50%);
        color: var(--btnBgColor);
        opacity: 1;
      }
    }
    .icon_text {
      margin: 35px 0 50px;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      letter-spacing: 2px;
      color: var(--btnBgColor);
    }
  }
  // 订单信息
  .order_msg_wrap {
    padding: 0 15px;
    margin-bottom: 40px;
    .order_msg_content {
      border-radius: 5px;
      // box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 4px rgba(0, 102, 153, 0.35);
      padding: 0 15px;
      .order_msg_item {
        padding: 14px 0;
        width: 100%;
        min-height: 22px;
        box-sizing: border-box;
        font-size: 14px;
        border-bottom: 1px solid #f5f5f5;
        &:last-child {
          border-bottom: none;
        }
        .order_msg_title {
          display: inline-block;
          width: 25%;
          vertical-align: middle;
          line-height: 22px;
          font-weight: bold;
          letter-spacing: 0.5px;
        }
        .order_msg {
          display: inline-block;
          vertical-align: middle;
          width: 75%;
          line-height: 18px;
          color: #999;
          word-wrap: break-word;
          word-break: break-all;
          text-align: right;
        }
      }
    }
  }
  // 底部按钮
  .footer_wrap {
    // box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 8px #069;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 15px;
    z-index: 10;
    display: flex;
    box-sizing: border-box;
    .result_btn {
      background: var(--btnBgColor);
      border-color: var(--btnBgColor);
      color: var(--fontColor);
      font-size: 14px;
      letter-spacing: 1px;
      font-weight: bold;
      height: 40px;
      border-radius: 5px;
    }
    .continue_pay {
      height: 40px;
      letter-spacing: 3px;
      padding: 0 25px;
      font-size: 14px;
      box-sizing: border-box;
      width: 160px;
      background-color: var(--bgColor);
      border-color: var(--bgColor);
      color: var(--fontColor);
    }
    .wait_pay_wrap {
      display: flex;
      width: 100%;
      .price_warp {
        flex: 1;
        display: flex;
        font-size: 18px;
        font-weight: 700;
        .price_text {
          line-height: 40px;
        }
        .price_num {
          line-height: 40px;
          flex: 1;
        }
      }
      .wait_pay_btn {
        width: 120px;
        height: 40px;
        border-radius: 5px;
        color: var(--btnBgColor);
        border-color: var(--btnBgColor);
      }
    }
  }
  // 线下支付金额
  .amount_wrap {
    display: flex;
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 18px;
    .amount_num {
      color: var(--btnBgColor);
      font-size: 18px;
      font-weight: bold;
    }
  }
  // 转账说明
  .transfer_wrap {
    padding: 20px 15px 0;
    box-sizing: border-box;
    font-size: 12px;
    .transfer_item {
      margin-bottom: 5px;
      overflow: hidden;
      .transfer_item_text {
        line-height: 16px;
        margin-bottom: 5px;
      }
    }
  }
  .transfer_info_title {
    font-size: 14px;
    line-height: 16px;
    padding: 0 15px;
    margin-top: 10px;
  }
  .transfer_infos {
    padding: 10px 15px;
    .info_table {
      width: 100%;
      font-size: 14px;
      text-align: center;
      border: 1px solid #999;
      .info_table_tr {
        line-height: 24px;
        border-bottom: 1px solid #999;
        &:last-child {
          border-bottom: 0;
        }
        .info_item_name {
          width: 100px;
          padding: 0 5px;
          box-sizing: border-box;
          vertical-align: middle;
          border-right: 1px solid #999;
        }
        .info_item_text {
          padding: 0 5px;
        }
      }
    }
  }
  .notice_wrap {
    font-size: 14px;
    padding: 5px 15px;
    line-height: 18px;
    color: red;
    margin: 10px 0;
    box-shadow: 0px 0px 8px rgb(14, 110, 226);
  }
  .offline_desc {
    font-size: 14px;
    padding: 0 15px;
    .offline_desc_item {
      line-height: 18px;
    }
    .color_sty {
      color: red;
    }
  }
  .wxpay_code_wrap {
    padding: 0 15px;
    box-sizing: border-box;
    margin-top: 10px;
    .code_img {
      width: 85%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>